import { SEARCH_DEBOUNCE_MS } from '@/experiences/sales-portal/components/search-input';
import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

interface UsePricingSearchResult {
  clearSearch: () => void;
  debouncedSearchText: string;
  searchText: string;
  setSearchText: (text: string) => void;
}

export const usePricingSearch = (): UsePricingSearchResult => {
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText, debouncedControl] = useDebounce(
    searchText,
    SEARCH_DEBOUNCE_MS,
  );

  // Immediately flush empty search text to avoid empty state flickering
  useEffect(() => {
    if (!searchText) {
      debouncedControl.flush();
    }
  }, [searchText, debouncedControl]);

  const clearSearch = useCallback(() => setSearchText(''), []);

  return {
    clearSearch,
    debouncedSearchText,
    searchText,
    setSearchText,
  };
};
